import moment from 'moment';
import { APIKeyDetails } from '../constants/types';

export const formatErrorMessage = (errMsg: string | undefined): string => {
  if (typeof errMsg === 'string' && errMsg.length > 0) {
    const newMsg = errMsg.replace(/_/g, ' ');
    return `${newMsg.slice(0, 1)}${newMsg.slice(1).toLowerCase()}.`;
  } else {
    return 'Something went wrong.';
  }
};

/**
 *
 * @param {APIKeyDetails} instance
 * API Key object where to match the needed parameters.
 *
 * @param {string} messagePrefix
 * Phrase or sentence that will be prepended to the result text.
 *
 * @returns {Object}
 * Error message text and days left before expiry.
 */
export const getExpiringKeyMessage = (
  instance: APIKeyDetails,
  messagePrefix = '',
): { message: string; days: number } => {
  let message = '';

  const today = moment().endOf('day').valueOf();
  const expiryDate = moment(instance.expireAt).valueOf();
  const activeDays = Math.round(moment.duration(expiryDate - today).asDays());
  const keyDuration = moment(instance.expireAt).diff(
    moment(instance.activeFrom),
    'days',
  );

  if (instance.status !== 'Active' && instance.status !== 'Active in future') {
    return {
      message: '',
      days: 0,
    };
  }

  if (activeDays <= 1) {
    if (moment(instance.expireAt).isSame(moment(), 'day')) {
      message = 'today';
    } else {
      message = 'tomorrow';
    }
  } else if (
    (keyDuration <= 5 && activeDays <= 2) ||
    (keyDuration > 5 && keyDuration <= 7 && activeDays <= 3) ||
    (keyDuration > 7 && keyDuration <= 31 && activeDays <= 7) ||
    (keyDuration > 31 && activeDays <= 30)
  ) {
    message = `in ${activeDays} days`;
  }

  return {
    message: message ? messagePrefix + message : '',
    days: message ? activeDays : 0,
  };
};
